module.exports = __webpack_public_path__ + "img/H000050_pencil.bdaf986c.png";